<template>
  <div class="h-full">
    <div class="h-full flex flex-col gap-y-2 lg:gap-y-4">
      <div>
        <div class="flex justify-between items-center flex-wrap gap-2 relative lg:gap-3">
          <div class="w-full flex justify-center lg:absolute">
            <GrmSearch :value="testbankListFilter.searchText"
                       class="w-full lg:w-60"
                       ref="search"
                       @input="(value) => SET_TESTBANK_LIST_FILTER({ searchText: value })"
                       @clear="() => {
                         SET_TESTBANK_LIST_FILTER({ searchText: '' });
                         $refs.search.$refs.search.focus();
                       }"
            />
          </div>
          <ul class="flex items-center gap-x-2 relative">
            <li>
              <GrmSimpleSelect
                :value="testbankListFilter.size"
                :options="[
                  { value: 10, title: $t('common.table.count.ten') },
                  { value: 20, title: $t('common.table.count.twenty') },
                  { value: 30, title: $t('common.table.count.thirty') },
                  { value: 40, title: $t('common.table.count.forty') },
                  { value: 50, title: $t('common.table.count.fifty') },
                ]"
                @input="(value) => SET_TESTBANK_LIST_FILTER({ size: value })"
              />
            </li>
            <li>
              <GrmCheckbox id="inThisRoomCreate"
                           :value="testbankListFilter.inThisRoom"
                           @input="(value) => SET_TESTBANK_LIST_FILTER({ inThisRoom: value, roomId: value ? room.roomId : '' })"
              >{{ $t("testBank.onlyCreateThisRoom") }}</GrmCheckbox>
            </li>
          </ul>
          <GrmBtn class="relative"
                  :color="createTestbankColor"
                  :hover-color="createTestbankColor"
                  @click="onCreateTestbank"
          >{{ isCreateTestbank ? $t('testBank.regCancel') : $t('testBank.register') }}</GrmBtn>
        </div>
      </div>
      <div class="min-h-0 flex-1">
        <TestbankTable />
      </div>
    </div>
  </div>
</template>

<script>
import {mapActions, mapGetters, mapMutations, mapState} from "vuex";
import {debounce} from "lodash";

import GrmBtn from "@/components/Common/button/GrmBtn.vue";
import GrmSearch from "@/components/Common/search/GrmSearch.vue";
import TestbankTable from '@/components/Room/Testbank/TestbankTable';
import GrmSimpleSelect from '@/components/Common/select/GrmSimpleSelect';
import GrmCheckbox from "@/components/Common/input/GrmCheckbox.vue";

export default {
  name: 'RoomTestbankList',
  components: {
    GrmCheckbox,
    GrmBtn,
    GrmSearch,
    TestbankTable,
    GrmSimpleSelect,
  },
  computed: {
    ...mapState('testbank', [
      'testbankList',
      'testbankListFilter',
    ]),
    ...mapGetters('room', [
      'room'
    ]),
    isCreateTestbank() {
      return this.testbankList.content?.find(testbank => testbank.type === 'edit');
    },
    createTestbankColor() {
      return this.isCreateTestbank ? 'red' : 'blue';
    },
  },
  watch: {
    testbankListFilter: {
      handler() {
        this._getTestbankList();
      },
      deep: true,
    }
  },
  methods: {
    ...mapActions('testbank', [
      'getTestbankList',
    ]),
    ...mapMutations('testbank', [
      'CREATE_TESTBANK',
      'DELETE_TESTBANK',
      'SET_TESTBANK_LIST_FILTER',
    ]),

    _getTestbankList: debounce(function () {
      this.getTestbankList();
    }, 200, {
      leading: false,
      trailing: true,
    }),
    onCreateTestbank() {
      if (this.testbankList.content.find(testbank => testbank.type === 'edit')) {
        this.DELETE_TESTBANK({
          type: 'edit',
        });
        return;
      }

      this.CREATE_TESTBANK({
        type: 'edit',
        bankTitle: '',
      });
    },
  }
}
</script>